import DirectionsRunIcon from '@mui/icons-material/DirectionsRun';
import DirectionsWalkIcon from '@mui/icons-material/DirectionsWalk';
import DirectionsBikeIcon from '@mui/icons-material/DirectionsBike';
import PoolIcon from '@mui/icons-material/Pool';
import SelfImprovementIcon from '@mui/icons-material/SelfImprovement';
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import SportsTennisIcon from '@mui/icons-material/SportsTennis';
import SportsBasketballIcon from '@mui/icons-material/SportsBasketball';
import SportsSoccerIcon from '@mui/icons-material/SportsSoccer';
import TerrainIcon from '@mui/icons-material/Terrain';
import RowingIcon from '@mui/icons-material/Rowing';
import NightlifeIcon from '@mui/icons-material/Nightlife';
import SportsMartialArtsIcon from '@mui/icons-material/SportsMartialArts';
import HikingIcon from '@mui/icons-material/Hiking';
import SportsGymnasticsIcon from '@mui/icons-material/SportsGymnastics';

// Maps HealthKit's HealthWorkoutActivityType (see mobile health package enum)
// to a Polish label and a representative MUI icon.
const WORKOUT_TYPE_META = {
  RUNNING: { label: 'Bieganie', Icon: DirectionsRunIcon },
  WALKING: { label: 'Marsz', Icon: DirectionsWalkIcon },
  HIKING: { label: 'Wędrówka', Icon: HikingIcon },
  BIKING: { label: 'Jazda na rowerze', Icon: DirectionsBikeIcon },
  SWIMMING: { label: 'Pływanie', Icon: PoolIcon },
  SWIMMING_OPEN_WATER: { label: 'Pływanie', Icon: PoolIcon },
  SWIMMING_POOL: { label: 'Pływanie', Icon: PoolIcon },
  YOGA: { label: 'Joga', Icon: SelfImprovementIcon },
  PILATES: { label: 'Pilates', Icon: SelfImprovementIcon },
  FUNCTIONAL_STRENGTH_TRAINING: { label: 'Siłownia', Icon: FitnessCenterIcon },
  TRADITIONAL_STRENGTH_TRAINING: { label: 'Siłownia', Icon: FitnessCenterIcon },
  STRENGTH_TRAINING: { label: 'Siłownia', Icon: FitnessCenterIcon },
  HIGH_INTENSITY_INTERVAL_TRAINING: { label: 'HIIT', Icon: FitnessCenterIcon },
  ELLIPTICAL: { label: 'Orbitrek', Icon: DirectionsRunIcon },
  ROWING: { label: 'Wioślarstwo', Icon: RowingIcon },
  ROWING_MACHINE: { label: 'Wioślarstwo', Icon: RowingIcon },
  DANCING: { label: 'Taniec', Icon: NightlifeIcon },
  CARDIO_DANCE: { label: 'Taniec', Icon: NightlifeIcon },
  SOCIAL_DANCE: { label: 'Taniec', Icon: NightlifeIcon },
  TENNIS: { label: 'Tenis', Icon: SportsTennisIcon },
  BASKETBALL: { label: 'Koszykówka', Icon: SportsBasketballIcon },
  SOCCER: { label: 'Piłka nożna', Icon: SportsSoccerIcon },
  CLIMBING: { label: 'Wspinaczka', Icon: TerrainIcon },
  CROSS_TRAINING: { label: 'Trening mieszany', Icon: FitnessCenterIcon },
  MIXED_CARDIO: { label: 'Trening mieszany', Icon: FitnessCenterIcon },
  CORE_TRAINING: { label: 'Trening core', Icon: FitnessCenterIcon },
  MARTIAL_ARTS: { label: 'Sztuki walki', Icon: SportsMartialArtsIcon },
  KICKBOXING: { label: 'Kickboxing', Icon: SportsMartialArtsIcon },
  BOXING: { label: 'Boks', Icon: SportsMartialArtsIcon },
};

export function getWorkoutTypeMeta(workoutType) {
  if (workoutType && WORKOUT_TYPE_META[workoutType]) {
    return WORKOUT_TYPE_META[workoutType];
  }
  return {
    label: workoutType ? `Trening (${workoutType.toLowerCase().replace(/_/g, ' ')})` : 'Trening',
    Icon: SportsGymnasticsIcon,
  };
}
